import { render, staticRenderFns } from "./LiveConferenceSeries.vue?vue&type=template&id=3fcb428c&scoped=true"
import script from "./LiveConferenceSeries.vue?vue&type=script&lang=js"
export * from "./LiveConferenceSeries.vue?vue&type=script&lang=js"
import style0 from "./LiveConferenceSeries.vue?vue&type=style&index=0&id=3fcb428c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb428c",
  null
  
)

export default component.exports